import { buildAxonItem, getAxonUserData, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonPurchase() {
  function reportPurchase(item: {
    item_id: string | number
    item_name: string
    price: string | number
  }, transactionId: string) {
    pushAxonEvent('purchase', {
      currency: 'USD',
      value: Number(item.price),
      shipping: 0,
      tax: 0,
      transaction_id: transactionId,
      user_data: getAxonUserData(),
      items: [buildAxonItem({ ...item, quantity: 1 })],
    })
  }

  return { reportPurchase }
}
